module.exports = __webpack_public_path__ + "img/preview-1.5a81b8bf.png";